import { Linking } from 'react-native';

/**
 * Reencender el agente instalado desde la app: el protocolo vuelto-agent://
 * (registrado por el instalador v0.4.0+) hace que Windows lance el exe.
 * Si el scheme no existe (instalación vieja o nunca instalado), el browser
 * pregunta y no pasa nada / Linking tira en nativo — el caller re-prueba
 * /health después y muestra el fallback de descarga.
 */
export async function launchPrintAgent(): Promise<void> {
  await Linking.openURL('vuelto-agent://start');
}
